import { Component } from '@angular/core';

import { IsOnlineBaseComponent } from '@app/shared/is-online-base.component';

@Component({
  selector: 'app-is-online-status',
  templateUrl: './is-online-status.component.html',
  imports: [],
})
export class IsOnlineStatusComponent extends IsOnlineBaseComponent {}
